export enum ReadyStateScript {
  loaded = 'loaded',
  complete = 'complete',
}
